import React, { useState } from 'react';
import {
  Box,
  Typography,
  Chip,
  Card,
  CardContent,
  Grid,
  Avatar,
  Tooltip,
  IconButton,
} from '@mui/material';
import { Edit, Delete, Person } from '@mui/icons-material';
import ConfirmDialog from '../../../ui-component/confirm_dialog';

const OfficerItem = ({ officer, index, registeredAddress, onRemove }) => {
  const [openConfirm, setOpenConfirm] = useState(false);

  const handleConfirm = () => {
    onRemove(index);
    setOpenConfirm(false);
  };

  const serviceAddress =
    officer.serviceAddress !== ''
      ? `${registeredAddress.street}, ${registeredAddress.city}, ${registeredAddress.postalCode}`
      : officer.address
        ? `${officer.address.street}, ${officer.address.city}, ${officer.address.postalCode}`
        : 'Address not specified';

  return (
    <>
      <Card variant="outlined" sx={{ mb: 2, borderRadius: 2 }}>
        <CardContent sx={{ p: 2 }}>
          <Grid container spacing={1} alignItems="flex-start">
            <Grid item>
              <Avatar sx={{ mt: 0.5 }}>
                <Person />
              </Avatar>
            </Grid>

            <Grid item xs sx={{ ml: 1.5 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  mb: 0.5,
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <Typography variant="subtitle1" fontWeight="bold">
                    {officer.name}
                  </Typography>
                  <Chip
                    label={
                      officer.role.charAt(0).toUpperCase() +
                      officer.role.slice(1)
                    }
                    size="small"
                    color="primary"
                    sx={{ ml: 1 }}
                  />
                </Box>

                <Box>
                  <Tooltip title="Edit" arrow>
                    <IconButton size="small" sx={{ ml: 1 }}>
                      <Edit fontSize="small" />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title="Remove" arrow>
                    <IconButton
                      size="small"
                      color="error"
                      sx={{ ml: 1 }}
                      onClick={() => setOpenConfirm(true)}
                    >
                      <Delete fontSize="small" />
                    </IconButton>
                  </Tooltip>
                </Box>
              </Box>

              <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                {serviceAddress}
              </Typography>

              <Box sx={{ display: 'flex', gap: 2 }}>
                <Typography variant="caption">
                  <strong>DOB:</strong> {officer.dateOfBirth || 'Not specified'}
                </Typography>
                <Typography variant="caption">
                  <strong>Nationality:</strong>{' '}
                  {officer.nationality || 'Not specified'}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </CardContent>
      </Card>

      <ConfirmDialog
        open={openConfirm}
        title="Confirm Removal"
        content={`Are you sure you want to remove ${officer.name}?`}
        onClose={() => setOpenConfirm(false)}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default OfficerItem;
